import { Component, OnInit, OnDestroy, HostListener, ElementRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LocaleService } from '@core/i18n/locale.service';
import { LOCALE_CONSTANTS } from '@core/i18n/locale.constants';
import { AuthService } from '@core/auth.service';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss']
})
export class LanguageSwitcherComponent implements OnInit, OnDestroy {
  @Input() isEditMode = false;

  readonly labels = LOCALE_CONSTANTS.LABELS;
  readonly languages = LOCALE_CONSTANTS.SUPPORTED_LANGUAGES;

  currentLocale: string;
  isDropdownOpen = false;
  searchTerm = '';
  filteredLanguages = [...this.languages];

  private localeSubscription: Subscription;

  constructor(
    private readonly localeService: LocaleService,
    private readonly elementRef: ElementRef,
    public authService: AuthService
  ) {
    this.currentLocale = this.localeService.currentLocale;
  }

  ngOnInit(): void {
    this.localeSubscription = this.localeService.locale$.subscribe((locale) => {
      this.currentLocale = locale;
    });
  }

  get currentLanguageName(): string {
    const lang = this.languages.find((l) => l.code === this.currentLocale);
    return lang ? lang.name : LOCALE_CONSTANTS.SUPPORTED_LANGUAGES[0].name;
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
    if (this.isDropdownOpen) {
      this.searchTerm = '';
      this.filteredLanguages = [...this.languages];
    }
  }

  selectLanguage(langCode: string): void {
    this.localeService.setLocale(langCode);
    this.isDropdownOpen = false;
  }

  onSearch(): void {
    const term = this.searchTerm.toLowerCase().trim();
    if (!term) {
      this.filteredLanguages = [...this.languages];
      return;
    }
    this.filteredLanguages = this.languages.filter(
      (l) => l.name.toLowerCase().includes(term) ||
        l.englishName.toLowerCase().includes(term) ||
        l.code.toLowerCase().includes(term)
    );
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }

  ngOnDestroy(): void {
    this.localeSubscription?.unsubscribe();
  }
}
